import { ArrowUpRight } from "lucide-react";
import { trackEvent } from "@/lib/track";

export const BuyButton = ({ s, testId, size = "lg", className = "" }) => {
  const external = Boolean(s?.buy_url);
  const pad = size === "lg" ? "px-7 py-4 text-base" : "px-5 py-2.5 text-sm";
  return (
    <a
      href={external ? s.buy_url : "#pricing"}
      target={external ? "_blank" : undefined}
      rel={external ? "noopener noreferrer" : undefined}
      onClick={() => trackEvent("buy_click")}
      data-testid={testId}
      className={`btn-shine group relative inline-flex items-center justify-center gap-2 overflow-hidden rounded-full bg-[#FACC15] font-display font-bold uppercase tracking-wide text-[#070B14] shadow-[0_0_40px_-6px_rgba(250,204,21,0.7)] transition-[transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:shadow-[0_0_60px_-4px_rgba(250,204,21,0.9)] active:translate-y-0 ${pad} ${className}`}
    >
      <span className="relative">{s?.buy_text || "Buy Now"}{size === "lg" ? ` — $${s?.price ?? "99"}` : ""}</span>
      <ArrowUpRight className="relative h-5 w-5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </a>
  );
};
